import { render, staticRenderFns } from "./GeneralEntityConfiguration.vue?vue&type=template&id=44f12504&scoped=true&"
import script from "./GeneralEntityConfiguration.vue?vue&type=script&lang=js&"
export * from "./GeneralEntityConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./GeneralEntityConfiguration.vue?vue&type=style&index=0&id=44f12504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f12504",
  null
  
)

export default component.exports